import { RestManagerWithoutBaseUrl } from '../RestManager';
import endpoints, { formatEndpoint } from '../endpoints';


class ConfiguredNotifications {

    getBroadcastedMessages(broadcastMessageID) {
        let endpoint;
        if (broadcastMessageID) {
            endpoint = formatEndpoint({
                ...endpoints.notification.getBroadcastedMessages,
                url: endpoints.notification.getBroadcastedMessages.url + '?broadcastMessageID={broadcastMessageID}'
            }, { broadcastMessageID });
        } else {
            endpoint = formatEndpoint(endpoints.notification.getBroadcastedMessages, {});
        }
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    removeBroadcastedMessageForUser(broadcastMessageId, userId) {
        const endpoint = formatEndpoint(endpoints.notification.deleteUserBroadcastMessage, { broadcastMessageId, userId });
        return RestManagerWithoutBaseUrl.put(endpoint);
    }
}

export default new ConfiguredNotifications();
